import Vue from "Vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { KeyValue } from "../../../components/calendrier/calendrier.model";

@Component
export default class InputSelect extends Vue {
    @Prop({ default: "" })
    public label;

    @Prop()
    private vmodel = "";

    @Prop({ default: false })
    private disabled;

    @Prop({ default: false })
    private error;

    @Prop({ default: true })
    private first;

    @Prop({ default: false })
    private textSmall;

    @Prop({ default: false })
    private textBold;

    @Prop({ default: false })
    private textUppercase;

    @Prop({ default: false })
    private textLowerCaseButFirst;

    @Prop({ default: false })
    private overflowList;

    @Prop({ default: false })
    private truncMiddle;

    @Prop({ default: true })
    private show;

    @Prop({ default: 0 })
    private height;

    @Prop({ default: "" })
    private code;

    @Prop({ default: "" })
    private display;

    @Prop({ default: "" })
    private displayInit;

    @Prop({ default: false })
    private required;

    @Prop()
    public list: KeyValue[] = [];

    @Prop({ default: false })
    private mini;

    @Prop({ default: true })
    private autoSort;

    public value = "";
    public title = "";
    public isDisplay = false;
    public isSearch = false;
    public choice = false;
    public listFormated = false;
    private init = true;
    public activeScroll = true;
    private inputElement;
    private thumbElement;
    private wrapElement;
    private insideElement;
    private viewHeight = 0;
    private sizeThumb = 0;
    private totalHeight = 0;

    @Watch("list", { immediate: true })
    private listenList(): void {
        if (this.list.length && !this.listFormated) {
            this.listFormated = true;
            this.formatList();
        }
    }

    @Watch("vmodel", { immediate: true })
    private setValue(): void {
        if (!this.init) {
            this.inputElement = <HTMLUListElement>this.$refs.input;
            if (this.inputElement !== undefined) {
                this.inputElement.blur();
            }
        }

        this.init = false;

        // Tri par ordre alphabétique
        if (this.autoSort) {
            this.list = this.list.sort(this.dynamicSort());
        }
        this.formatList();
    }

    private formatList(): void {
        // Fait correspondre la valeur du vmodel avec la bonne valeur d'affichage dans l'input
        this.value = this.list.filter(item => item[this.code] === this.vmodel).map(item => item[this.display])[0];

        // Change le titre
        this.title = this.value;
    }

    private setSizeScroll(): void {
        this.insideElement = <HTMLUListElement>this.$refs.inside;
        this.thumbElement = <HTMLUListElement>this.$refs.thumb;
        this.wrapElement = <HTMLUListElement>this.$refs.wrap;

        let scrollSize;

        // Limite la hauteur de la liste
        if (this.height == 0) {
            scrollSize = document.body.clientHeight - this.insideElement.getBoundingClientRect().top - 15;
        } else {
            scrollSize = this.height;
        }
        this.insideElement.style.maxHeight = scrollSize + "px";

        // Custom scrollbar
        this.totalHeight = parseInt(this.insideElement.scrollHeight, 10);
        this.viewHeight = parseInt(this.wrapElement.offsetHeight, 10);
        this.sizeThumb = Math.round(this.viewHeight * this.viewHeight / this.totalHeight);

        this.thumbElement.style.height = this.sizeThumb + "px";

        // Active / Désactive scrollbar si nécessaire
        this.activeScroll = (this.totalHeight > this.viewHeight);

        // Init custom scrollbar
        this.scroll();
    }

    public scroll(): void {
        this.insideElement = <HTMLUListElement>this.$refs.inside;
        const pos = this.insideElement.scrollTop / this.viewHeight * this.sizeThumb;
        this.thumbElement.style.top = pos + "px";
    }

    public clickInput(): void {
        if (this.isDisplay) {
            this.inputElement = <HTMLUListElement>this.$refs.input;
            this.inputElement.blur();
            this.blur();
        } else {
            this.isDisplay = true;
        }
    }

    public mousedown(e: any): void {
        e.preventDefault();
    }

    public clickItem(item: string): void {
        if (this.checkIfSelected(item[this.code])) {
            return;
        }

        if (item[this.code] === undefined) {
            if (this.vmodel == "") {
                this.inputElement = <HTMLUListElement>this.$refs.input;
                this.inputElement.blur();
            } else {
                this.value = "";
                this.vmodel = "";
            }
        } else if (this.vmodel != item[this.code]) {
            this.value = item[this.display];
            this.vmodel = item[this.code];
        }
    }

    public blur(): void {
        if (!this.isSearch) {
            // Désactive l'affichage de la liste
            this.isDisplay = false;

            // Envoie les différentes actions au composant parent
            this.$emit("update:vmodel", this.vmodel);
            this.$emit("change");

            // Attends la fin de la transtion de masquage de la liste (0.2s)
            setTimeout(this.afterHideList, 200);
        }
    }

    private afterHideList(): void {
        // Reset la position de la scrollbar de la liste
        this.insideElement = <HTMLUListElement>this.$refs.inside;
        this.insideElement.scrollTop = 0;
    }

    private dynamicSort(): any {
        const property = this.display;

        return function (a: any, b: any): number {
            return (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        };
    }

    private truncMiddleText(text: string): string {
        if (text === undefined || text === "") {
            return "";
        }

        if (this.truncMiddle) {
            const maxLength = 28;

            if (Array.isArray(text)) {
                text = text[0];
            }

            if (text.length > maxLength) {
                const textStart = text.slice(0, maxLength / 2);
                const textEnd = text.slice(-(maxLength / 2));

                text = textStart + "..." + textEnd;
            }
        }

        return text;
    }

    public checkIfSelected(code: string): boolean {
        return this.vmodel === code;
    }

    private toLowerCaseButFirst(text: string): string {
        text = text.toLowerCase();
        text = text.charAt(0).toUpperCase() + text.slice(1);
        return text;
    }
}



// WEBPACK FOOTER //
// ./src/shared/components/InputSelect/InputSelect.ts